//export const siteUrl = "https://atlantis-shop.liara.run/";
//export const authUrl = "https://atlantis-auth.liara.run/";

export const siteUrl = "https://shopapi.atldmo.ir/";
export const authUrl = "https://auth.atldmo.ir/";

export const success = "success";
export const info = "info";
export const error = "error";
export const warning = "warning";
export const successSubmit = "Your info has been modified";
export const UnsuccessSubmit = "A problem has been occured (not modified info)";

export const options = {
  responsive: "scroll",
  filter: false,
  print: false,
  download: false,
  viewColumns: false,
  selectableRows: "none",
  textLabels: {
    body: {
      noMatch: "Sorry, no matching records found",
      toolTip: "Sort"
    },
    pagination: {
      next: "Next Page",
      previous: "Previous Page",
      rowsPerPage: "Rows per page:",
      displayRows: "of"
    },
    toolbar: {
      search: "Search",
      downloadCsv: "Download CSV",
      print: "Print",
      viewColumns: "View Columns",
      filterTable: "Filter Table"
    },
    filter: {
      all: "All",
      title: "FILTERS",
      reset: "RESET"
    },
    viewColumns: {
      title: "Show Columns",
      titleAria: "Show/Hide Table Columns"
    },
    selectedRows: {
      text: "row(s) selected",
      delete: "Delete",
      deleteAria: "Delete Selected Rows"
    }
  }
};
export const optionsfa = {
  responsive: "scroll",
  rowsPerPage: 50,
  rowsPerPageOptions: [50, 100, 200, 500],
  download: false,
  print: false,
  filterType: "checkbox",
  viewColumns: false,
  filter: false,

  textLabels: {
    body: {
      noMatch: "متاسفانه نتیجه ای یافت نشد",
      toolTip: "مرتب سازی"
    },
    pagination: {
      next: "صفحه بعد",
      previous: "صفحه قبل",
      rowsPerPage: "تعداد در هر صفحه :",
      displayRows: "ِ"
    },
    toolbar: {
      search: "جستجو",
      downloadCsv: "دانلود به صورت CSV",
      print: "پرینت",
      viewColumns: "ستونهای قابل مشاهده",
      filterTable: "فیلتر کردن جدول"
    },
    filter: {
      all: "همه",
      title: "فیلترها",
      reset: "شروع مجدد"
    },
    viewColumns: {
      title: "ستون های نمایش داده شده",
      titleAria: "نمایش/مخفی کردن ستون های جدول"
    },
    selectedRows: {
      text: "ردیف(های) انتخاب شده",
      delete: "حذف",
      deleteAria: "حذف ستون های انتخاب شده"
    }
  }
};
export const MasterKey = "0RYd3LonA8zGI3VbVXCO2cTk1vm4dW7u";
